import { plugin, debug } from 'light-component';
import dayjs from 'dayjs';
import { useEffect, useState, type ReactElement } from 'react';
import { DatePicker } from 'antd';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { DatePickerProps } from 'antd';
import type { Dayjs } from 'dayjs';
import type { DateProps } from './types';

export function WidgetDate(props: DateProps): ReactElement {
  debug.widget('dashboard date', props);
  const { allowClear = true } = props;
  const [date, setDate] = useState<Dayjs | null>(null);
  const [maxDate, setMaxDate] = useState<Dayjs>();
  const [minDate, setMinDate] = useState<Dayjs>();

  useEffect(() => {
    if (props.maxDate == null) {
      return;
    }
    props.maxDate === '$now' ? setMaxDate(dayjs()) : setMaxDate(dayjs(props.maxDate));
  }, [props.maxDate]);

  useEffect(() => {
    if (props.minDate == null) {
      return;
    }
    props.minDate === '$now' ? setMinDate(dayjs()) : setMinDate(dayjs(props.minDate));
  }, [props.minDate]);

  useEffect(() => {
    const date = props.value ?? null;
    const startDate = typeof (date) === 'string' ? dayjs(date) : date;

    setDate(startDate);
  }, [props.value]);

  const getYearMonth = (date: Dayjs): number => (date.year() * 12) + date.month();

  const disabledDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
    if (from != null) {
      const minDate = from.add(-props.maxRange + 1, 'days');
      const maxDate = from.add(props.maxRange - 1, 'days');

      switch (type) {
        case 'year':
          return current.year() < minDate.year() || current.year() > maxDate.year();

        case 'month':
          return (
            getYearMonth(current) < getYearMonth(minDate)
            || getYearMonth(current) > getYearMonth(maxDate)
          );

        default:
          return Math.abs(current.diff(from, 'days')) >= props.maxRange;
      }
    }

    return false;
  };

  // 监听日期选择器的日历变化
  function onChange(date: Dayjs | null): void {
    const formattedDate = date != null ? dayjs(date).format('YYYY-MM-DD') : date;
    props.onChange?.(formattedDate);
  }

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title ?? '')}</span>
      </div>
      <DatePicker
        className={styles.treeSelect}
        placeholder={props.placeholder != null ? t(props.placeholder) : undefined}
        allowClear={allowClear}
        disabled={props.disabled}
        picker={props.picker ?? 'date'}
        value={date}
        disabledDate={disabledDate}
        onChange={onChange}
        onPanelChange={onChange}
        maxDate={maxDate}
        minDate={minDate}
      />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'date', component: WidgetDate });
